export const [ mmolL, mgdL ] = ['mmol/l', 'mg/dl'];

export const internalUnits = mgdL;

export const consts = {
  [mmolL]: {
    ticks: {
      max: 20,
      hyper: 14,
      high: 10,
      low: 3.9,
      hypo: 3,
      min: 0,
    },
  },
  [mgdL]: {
    ticks: {
      max: 350,
      hyper: 250,
      high: 180,
      low: 70,
      hypo: 54,
      min: 0,
    },
  },
};

export const degrees = 180 / Math.PI;

export default consts;
